import { Box } from '@mui/system'
import { ButtonBase, Grid, GridSize, Paper, Typography } from '@mui/material'

type attributeObj = {
  variant?: string
  value: string | number
  color?: string
}

type attribute = string | attributeObj

function GridCard({
  onClick,
  id,
  size,
  title,
  attributes,
  subtitle,
  ...props
}: {
  onClick?: any
  id: string | number
  size: GridSize
  title?: string
  subtitle?: string
  attributes?: attribute[]
  props?: any
}) {
  return (
    <Grid
      item
      xs={size}
      key={id}
      {  ...props}
    >
      <ButtonBase
        onClick={onClick}
        disabled={!onClick}
        sx={{ width: 1 }}
      >
        <Paper
          elevation={3}
          sx={{ width: 1, p: 1 }}
        >
          {title && (
            <Typography
              aria-label={'Title'}
              variant="subtitle2"
            >
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography
              aria-label={'Subtitle'}
              variant="body1"
            >
              {subtitle}
            </Typography>
          )}
          {attributes && attributes.length > 0 && (
            <Box
              sx={{
                display: 'flex',
                width: 1,
                justifyContent: 'space-between',
              }}
            >
              {attributes.map((item, index) => {
                return (
                  <Typography
                    key={index}
                    variant="body2"
                    color={typeof item !== 'string' ? item?.color : undefined}
                  >
                    {typeof item === 'string' ? item : item?.value}
                  </Typography>
                )
              })}
            </Box>
          )}
        </Paper>
      </ButtonBase>
    </Grid>
  )
}

export default GridCard
